export default function DataOpenDirective(module) {
    angular.module(module || 'app')
        .directive('open', dataOpen);

    dataOpen.$inject = [];
    function dataOpen() {
        var directive = {
            restrict: 'A',
            require: {
                modalLoader: '^^modalLoader'
            },
            bindToController: true,
            controller: controller
        };

        controller.$inject = ['$element', '$timeout'];
        function controller($element, $timeout) {
            var ctrl = this;
            ctrl.$onInit = function () {
                $timeout(function () {
                    ctrl.target = $element.data('open');
                    ctrl.modalLoader.load(ctrl.target);
                });
            };
        }

        return directive;
    }
};